import script from "./ProcessManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessManagement.vue?vue&type=script&setup=true&lang=js"

import "./ProcessManagement.vue?vue&type=style&index=0&id=5cb28288&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb28288"]])

export default __exports__